import { Box, Grid } from "@mui/material";
import { useDmsForm } from "../../../hooks/useDmsFrom";
import ControllerSelectInput from "../../../common-ui/analytics/ControllerSelectInput";

import { CountMetricsChart } from "../CountMetricsChart";

import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

import { ProgrammesCountQuery } from "../../../services/analytics/domain.analytics";
import { fetchProgrammesClassifier, updateProgrammesClassifier } from "../../../store/reducers/analytics/domain.metrics";

const GroupByOptions = [
  {
    label: "Division",
    value: "division",
  }
];

export const ProgrammesMetricsController = () => {
  const defaultQuery = { group_by: GroupByOptions[0].value };

  const { form, updateInputField, updateForm, getFormValues } =
    useDmsForm<ProgrammesCountQuery>({
      group_by: defaultQuery.group_by,
    });



  const classifier = useAppSelector((d) => d.domainMetrics.programmesClassifier);

  const dispatch = useAppDispatch();
  useEffect(() => {
    const query = getFormValues();
    dispatch(updateProgrammesClassifier({loading:true}));
    dispatch(fetchProgrammesClassifier(query));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    form.group_by?.value,
  ]);

  const renderController = () => {
    return (
      <Box
        sx={(theme) => ({
          [theme.breakpoints.down("lg")]: {
            width: "100%",
          },
          [theme.breakpoints.up("lg")]: {
            maxWidth: 900,
          },
        })}
      >
        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12, lg: 12 }}
        >
          <Grid item xs={2} sm={6} md={6} lg={3}>
            <ControllerSelectInput
              width={180}
              value={form.group_by?.value ?? undefined}
              placeholder="select classifier"
              items={GroupByOptions}
              handleChange={updateInputField("group_by")}
              label="Group By"
              loading={classifier?.loading ?? true}
            />
          </Grid>
        </Grid>
      </Box>
    );
  };

  const refresh = () => {
    const query = getFormValues();
    dispatch(updateProgrammesClassifier({loading:true}));
    dispatch(fetchProgrammesClassifier(query));
  };
  const reset = () => {
    dispatch(updateProgrammesClassifier({loading:true}));
    updateForm({ group_by: { value: defaultQuery.group_by } });
    dispatch(fetchProgrammesClassifier(defaultQuery));
  };
  return (
    <CountMetricsChart
    title="Domain Programmes Analytics"
      refresh={refresh}
      reset={reset}
      data={classifier?.data ?? {}}
      loading={classifier?.loading ?? true}
      controller={renderController()}
    />
  );
};
